// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hero-section {\n  background-size: cover;\n  background-position: top center;\n}\n\n.hero-section,\n.hero-section .section-text-wrapper {\n  min-height: 800px;\n}\n\n.hero-section br {\n  display: none;\n}\n\n@media screen and (min-width: 800px) {\n  .hero-section br {\n    display: unset;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
